<!--
  Generic component for previwing attachments on preview page for all forms.
-->

<template>
  <div v-if="filteredFormData.attachments && filteredFormData.attachments.length > 0">
    <div class="title-text font-weight-bold mt-5">
      Attachments
    </div>
    <attachments-viewer class="pt-3" :attachments="filteredFormData.attachments" :is-preview-mode="true" :viewFileAttachment="viewAttachment"/>
  </div>

</template>

<script>
import AttachmentsViewer from "@/components/Payments/AttachmentsViewer";

export default {
  name: "PreviewAttachments",
  components: {AttachmentsViewer},
  props: ['filteredFormData','viewAttachment']
}
</script>

<style scoped>

</style>